import React from 'react';
import ModernVodUploadForm from './ModernVodUploadForm';
import { UploadCloud } from 'lucide-react'; // Import UploadCloud icon
// Removed Material UI imports

interface VodUploadSectionProps {
  selectedWhisperModel: string; // Bu prop artık VodUploadForm tarafından kullanılmıyor.
  selectedWhisperDevice: 'cpu' | 'cuda'; // Dashboard'dan gelen cihaz (cpu/cuda)
  setSelectedWhisperModel: (value: string) => void; // Bu prop artık VodUploadForm tarafından kullanılmıyor.
  setSelectedWhisperDevice: (value: 'cpu' | 'cuda') => void; // Cihaz değiştirme fonksiyonu
  customLlmPrompt: string;
  setCustomLlmPrompt: (value: string) => void;
  clipCount: number;
  setClipCount: (value: number) => void;
  customPromptAllowed?: boolean;
  // ffmpegSettings ve editorSettings propları kaldırıldı, çünkü arayüzde gösterilmeyecekler.
  // ffmpegSettings?: { resolution: string; fps: number };
  // editorSettings?: { resolution: string; fps: number };
  onBeforeUpload?: (isGpuAttempt: boolean) => Promise<boolean>; // VodUploadForm'a geçecek
  onAfterUpload?: (isGpuAttempt: boolean) => Promise<void>; // VodUploadForm'a geçecek
}

function VodUploadSection({
  // selectedWhisperModel, // Artık kullanılmıyor
  selectedWhisperDevice,
  // setSelectedWhisperModel, // Artık kullanılmıyor
  setSelectedWhisperDevice,
  customLlmPrompt,
  setCustomLlmPrompt,
  clipCount,
  setClipCount,
  customPromptAllowed = true,
  // ffmpegSettings, // Kaldırıldı
  // editorSettings, // Kaldırıldı
  onBeforeUpload,
  onAfterUpload
}: VodUploadSectionProps) {

  // handleModelChange kaldırıldı.
  // handleDeviceChange VodUploadForm'a taşınacak.

  return (
    <div className="h-full bg-card text-card-foreground rounded-lg shadow-md p-5"> {/* Replaced Card/CardContent/Box with div and added Tailwind classes */}
      <h3 className="text-lg font-semibold mb-4 pb-2 border-b border-border flex items-center text-foreground"> {/* Ensure text color is from theme */}
        <UploadCloud size={20} className="mr-2 text-primary" /> {/* Added UploadCloud icon with primary color */}
        Create Clips & Settings
      </h3>

      <div className="flex flex-col gap-4"> {/* Replaced Box with div and added Tailwind classes */}
        {/* Settings section at the top */}
        <div className="w-full">
          <ModernVodUploadForm
            // selectedWhisperModel prop'u ModernVodUploadForm'dan kaldırıldı.
            initialSelectedDevice={selectedWhisperDevice === 'cuda' ? 'GPU' : 'CPU'}
            onDeviceChange={(newDevice: 'CPU' | 'GPU') => {
              setSelectedWhisperDevice(newDevice === 'GPU' ? 'cuda' : 'cpu');
            }}
            customLlmPrompt={customLlmPrompt}
            setCustomLlmPrompt={setCustomLlmPrompt}
            clipCount={clipCount}
            setClipCount={setClipCount}
            customPromptAllowed={customPromptAllowed}
            onBeforeUpload={onBeforeUpload}
            onAfterUpload={onAfterUpload}
          />
        </div>
      </div>
    </div>
  );
}

export default VodUploadSection;